module.exports = __webpack_public_path__ + "img/u513.5616675c.svg";